import { ChangeDetectorRef, Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { PlanWizardService } from '@app/+authenticated/+account/billing/plan-wizard/plan-wizard.service';
import { SubscriptionService } from '@app/+authenticated/+reports/shared/subscriptions/subscription.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';
import { BillingService } from '@shared/billing/billing.service';
import { ContentStateComponent } from '@shared/content-state/content-state.component';
import { of, Subscription, switchMap } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'order-completion',
  templateUrl: './order-completion.component.html',
  imports: [TranslatePipe, ContentStateComponent, ButtonComponent],
  styles: [':host { display: block; }'],
})
export class OrderCompletionComponent implements OnInit, OnDestroy {
  private billingService = inject(BillingService);
  private planWizard = inject(PlanWizardService);
  private cd = inject(ChangeDetectorRef);
  private subscriptionService = inject(SubscriptionService);

  private dataSubs = new Subscription();

  validPaymentMethod: boolean;
  isLoading = true;

  @Output()
  closePressed = new EventEmitter();

  @Output()
  backPressed = new EventEmitter();

  ngOnInit() {
    const selectedSubscription = this.subscriptionService.getSelectedSubscription().value;

    if (!selectedSubscription?.subscription) {
      return;
    }
    this.dataSubs.add(
      this.billingService
        .getChargeBeePaymentMethod()
        .pipe(
          filter((paymentMethod) => !!paymentMethod),
          tap((paymentMethod) => {
            this.validPaymentMethod = paymentMethod?.status === 'valid';
          }),
          switchMap(() =>
            !this.validPaymentMethod
              ? of(null)
              : this.subscriptionService.saveSubscription({
                  subscriptionId: selectedSubscription.subscription.id,
                  integrationPlus: selectedSubscription.integrationPlus,
                  invoicePeriod: selectedSubscription.invoicePeriod,
                  compliance: selectedSubscription.compliance,
                  hrPlus: selectedSubscription.hrPlus,
                  chat: selectedSubscription.chat,
                }),
          ),
        )
        .subscribe({
          next: () => {
            this.isLoading = false;
            if (this.validPaymentMethod) {
              localStorage.setItem('planWizardLanding', 'completed');
            }
            this.planWizard.paymentReady$.next(true);
            this.planWizard.paymentValid$.next(this.validPaymentMethod);
            this.cd.detectChanges();
          },
        }),
    );
  }

  ngOnDestroy() {
    this.dataSubs.unsubscribe();
  }
}
